export default function resolveGameConfig(
  difficultyOrConfig,
  gameConfig,
  fallbackDifficulty = "easy"
) {
  if (
    typeof difficultyOrConfig === "object" &&
    difficultyOrConfig !== null
  ) {
    return {
      difficultyKey: "custom",
      config: {
        label:
          difficultyOrConfig.label || "Personalizada",
        ...difficultyOrConfig,
      },
    };
  }

  const difficultyKey =
    difficultyOrConfig || fallbackDifficulty;

  return {
    difficultyKey,
    config:
      gameConfig[difficultyKey] ||
      gameConfig[fallbackDifficulty],
  };
}